export const getStatusesConstants = {
  STATUSES_ORDERS_REQUEST: "STATUSES_ORDERS_REQUEST",
  STATUSES_ORDERS_SUCCESS: "STATUSES_ORDERS_SUCCESS",
  STATUSES_ORDERS_FAILURE: "STATUSES_ORDERS_FAILURE"
};
